import styled from '@emotion/styled'
import { Typography } from '@mui/material'
import { FC } from 'react'
import { Colors } from 'src/components/theme'
import { PARCEL_TYPES_MAP } from 'src/constants/cherre-data-dictionary/zoning-colors'
import { ParcelTypeChip } from 'src/v2/components/parcel-type-chip'
import { PercentageBar } from 'src/v2/components/percentage-bar'

const Container = styled.div<{ hideBorder: 1 | 0 }>`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 20px;
  padding-top: 2px;
  border-bottom: ${({ hideBorder }) => (hideBorder ? 'none' : `solid 1px ${Colors.neutral100}`)};
`

const ChipContainer = styled.div`
  flex: 1;
`

const PercentageContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  flex: 1;
  gap: 16px;
`

const PercentageBarContainer = styled.div`
  display: flex;
  width: 100px;
`

type PropertiesDistributionItemProps = {
  type: string
  value: number
  percentage: number
  hideBorder?: boolean
}

export const PropertiesDistributionItem: FC<PropertiesDistributionItemProps> = ({
  type,
  value,
  percentage,
  hideBorder = false,
}) => {
  const propertyType = PARCEL_TYPES_MAP.get(type)

  if (!propertyType) {
    return null
  }

  return (
    <Container hideBorder={hideBorder ? 1 : 0}>
      <ChipContainer>
        <ParcelTypeChip type={type} />
      </ChipContainer>
      <PercentageContainer>
        <Typography variant="textmdm" color={Colors.neutral500} whiteSpace="nowrap">
          {`${value} (${Math.round(percentage * 100)}%)`}
        </Typography>
        <PercentageBarContainer>
          <PercentageBar percentages={{ [propertyType.color]: percentage }} />
        </PercentageBarContainer>
      </PercentageContainer>
    </Container>
  )
}
